import { render, staticRenderFns } from "./orgin.vue?vue&type=template&id=353f52cc&scoped=true"
import script from "./orgin.vue?vue&type=script&lang=js"
export * from "./orgin.vue?vue&type=script&lang=js"
import style0 from "./orgin.vue?vue&type=style&index=0&id=353f52cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f52cc",
  null
  
)

export default component.exports